import styled from 'styled-components'

// import { mq, sizes } from '../../theme'
import VideoYoutube from '../VideoYoutube'
import Transcript from '../Transcript'
import { mq, pxToRem, sizes } from '../../theme'

export const Container = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(24)};
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(40)};
  }
`
export const _VideoYoutube = styled(VideoYoutube)``
export const _Transcript = styled(Transcript)``
